<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    <breadcrumb-template
      :headtitle="$route.meta.title"
      :breadcrumbcurrent="$route.meta.title"
    ></breadcrumb-template>
    <v-card class="card-outline force-remove-box">
      <v-card-text class="force-custom-bg">
        <v-container fluid>
          <v-row dense class="d-flex justify-end mt-n2">
            <!-- <v-col cols="12" lg="4" class="span-label">
              <span class="control-label">Region</span>
              <v-combobox
                dense
                clearable
                hide-details
                class="regular-field"
                :items="region_list"
                item-value="id"
                item-text="region_name"
                label="Region"
                v-model="filter.region_id"
              ></v-combobox>
            </v-col> -->
            <!-- <v-col cols="12" lg="4" class="span-label">
              <span>Area</span>
              <v-combobox
                class="regular-field"
                :items="arealist"
                item-value="id"
                item-text="name"
                label="Area"
                v-model="filter.zone_id"
              ></v-combobox>
            </v-col> -->
            <!-- <v-col cols="12" lg="2" class="span-label">
              <span>Status</span>
              <v-select
                class="regular-field"
                dense
                clearable
                :items="['Active', 'Inactive']"
                label="Status"
                v-model="filter.status"
              ></v-select>
            </v-col> -->
            <!-- <v-col cols="12" md="4">
              <v-text-field
                dense
                class="regular-field remove-alignment-clear-icon"
                v-model="dt_searchQuery"
                label="Search any keyword"
              ></v-text-field>
            </v-col> -->

            <!-- <v-col
              cols="12"
              class="mt-7"
              style="padding-top:5px;"
              sm="12"
              md="2"
              lg="2"
            >
              <v-btn
                color="green_button"
                class="float-right btn-block"
                @click="getDataFromApi()"
                >Search</v-btn
              >
            </v-col> -->

            <!-- <v-col
              cols="12"
              class="mt-7"
              style="padding-top:5px;"
              md="2"
              lg="2"
              sm="12"
              v-if="$role.restricAccess($route.name, 'add')"
            >
              <v-btn
                color="info"
                class="float-right btn-block"
                @click="modalForm"
                >Add draw</v-btn
              >
            </v-col> -->

            <v-col cols="12" class="mt-2">
              <v-data-table
                class="custom-header-color remove-id-col-mobile table-bordered table-striped"
                :headers="dt_headers"
                :items="dt_resultlist"
                item-key="id"
                :loading="dt_loading"
                :options.sync="dt_options"
                :server-items-length="dt_totalResult"
              >
                <template v-slot:[`item.timeschedule`]="{ item }">{{
                  item.timeschedule | timeFilter
                }}</template>
                <template v-slot:[`item.timetoopen`]="{ item }">{{
                  item.timetoopen | timeFilter
                }}</template>
                <template v-slot:[`item.timetoclose`]="{ item }">{{
                  item.timetoclose | timeFilter
                }}</template>
                <template v-slot:[`item.schedule_draw`]="{ item }">{{
                  schedule_draw_format(item.schedule_draw)
                }}</template>
                <template v-slot:[`item.status`]="{ item }">{{
                  item.status == 1 ?  "Active" : item.status == 2 ? "Deleted" : "Inactive"
                }}</template>

                <!-- <template v-slot:[`item.schedule`]="{ item }">{{
                  abri(item.schedule)
                }}</template> -->

                <template
                  v-slot:[`item.actions`]="{ item }"
                  v-if="$role.restricAccess($route.name, 'edit')"
                >
                  <v-btn
                    color="info"
                    block
                    dark
                    small
                    @click="findData(item)"
                    :disabled="isEditButtonDisabled(item)"
                  >
                    Edit
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <section>
      <v-dialog v-model="dialogForm" width="992px" scrollable persistent>
        <v-card class="card-outline custom-color-dialog">
          <v-card-title class="headline headline_bg">
            <span v-if="modalUpdate">Update draw</span>
            <span v-else>Create draw</span>
          </v-card-title>

          <v-card-text>
            <ul class="nav nav-tabs" role="tablist" style="margin-top:20px">
              <li class="nav-item">
                <span
                  style="cursor:pointer"
                  class="nav-link active"
                  data-toggle="tab"
                  href="#generalmenu"
                  >General</span
                >
              </li>
              <li class="nav-item">
                <span
                  style="cursor:pointer"
                  class="nav-link"
                  data-toggle="tab"
                  href="#maxbet"
                  >Bulk max bet</span
                >
              </li>
            </ul>
            <div class="tab-content">
              <div id="generalmenu" class="container tab-pane active">
                <v-row dense class="pt-6">
                  <v-col cols="12" class="mt-n5">
                    <v-switch
                      color="info"
                      dense
                      inset
                      v-model="form.status"
                      label="Status"
                      class="float-right"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" class="mt-n5">
                   <vue-upload-multiple-image
                        @upload-success="uploadImageSuccess"
                        @before-remove="beforeRemove"
                        @edit-image="editImage"
                        :data-images="form.gallery"
                        dragText="Drag or upload image here"
                        idUpload="myIdUpload"
                        editUpload="myIdEdit"
                        primaryText=" "
                        browseText=" "
                        markIsPrimaryText=" "
                        dropText=" "
                        :multiple="false"
                    ></vue-upload-multiple-image>
                      <!-- <has-error :form="form" field="gallery"></has-error> -->
                  </v-col>
                  <v-col cols="12" lg="6">
                    <v-text-field
                      dense
                      class="regular-field"
                      v-model="form.name"
                      label="Name"
                      :error-messages="formerror.name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <v-text-field
                      dense
                      class="regular-field"
                      v-model="form.codename"
                      label="Code name"
                      :error-messages="formerror.codename"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <v-text-field
                      dense
                      class="regular-field"
                      v-model="form.minimumbet"
                      label="Minimum bet"
                      type="number"
                      :error-messages="formerror.minimumbet"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <v-text-field
                      dense
                      class="regular-field"
                      v-model="form.maxbet"
                      label="Maximum bet"
                      type="number"
                      :error-messages="formerror.maxbet"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <v-text-field
                      dense
                      class="regular-field"
                      v-model="form.amount_increment"
                      label="Amount increment"
                      type="number"
                      :error-messages="formerror.amount_increment"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <v-text-field
                      dense
                      class="regular-field"
                      v-model="form.max_accumulated"
                      label="Maximum accumulated bet limit per combination"
                      type="number"
                      :error-messages="formerror.max_accumulated"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <v-text-field
                      dense
                      class="regular-field"
                      v-model="form.maxinput"
                      label="Combination length"
                      type="number"
                      :error-messages="formerror.maxinput"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" class="span-label">
                    <span class="control-label">Number format</span>
                    <v-select
                      dense
                      class="regular-field"
                      :items="['0-9', '0-99']"
                      v-model="form.numberformat"
                      label="Number format"
                      :error-messages="formerror.numberformat"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" lg="6" class="span-label">
                    <span class="control-label">Schedule day</span>
                    <v-select
                      dense
                      class="regular-field"
                      :items="schedules"
                      item-text="name"
                      item-value="name"
                      v-model="form.schedule_draw"
                      label="Schedule day"
                      multiple
                      :error-messages="formerror.schedule_draw"
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip small v-if="index === 0"
                          ><span>{{ item.name }}</span></v-chip
                        >
                        <v-chip small v-if="index === 1"
                          ><span>{{ item.name }}</span></v-chip
                        >
                        <span v-if="index === 2" class="grey--text text-caption"
                          >(+{{ form.schedule_draw.length - 2 }} others)</span
                        >
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <v-text-field
                      dense
                      class="regular-field"
                      v-model="form.timeschedule"
                      label="Time schedule"
                      type="time"
                      :error-messages="formerror.timeschedule"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <v-text-field
                      dense
                      class="regular-field"
                      v-model="form.timetoopen"
                      label="Opening time"
                      type="time"
                      :error-messages="formerror.timetoopen"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <v-text-field
                      dense
                      class="regular-field"
                      v-model="form.timetoclose"
                      label="Cut-off time"
                      type="time"
                      :error-messages="formerror.timetoclose"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" class="span-label">
                    <span class="control-label">Area</span>
                    <v-select
                      :items="zone_list"
                      item-text="name"
                      item-value="id"
                      dense
                      class="regular-field"
                      v-model="form.zone_id"
                      label="Area"
                      :error-messages="formerror.draw_id"
                    >
                      <template slot="selection" slot-scope="data">
                        {{ data.item.region_code }} - {{ data.item.name }}
                      </template>
                      <template slot="item" slot-scope="data">
                        {{ data.item.region_code }} - {{ data.item.name }}
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <v-text-field
                      dense
                      class="regular-field"
                      v-model="form.winning_share"
                      label="Winning share (%)"
                      :error-messages="formerror.winning_share"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" lg="6">
                    <v-radio-group
                      dense
                      v-model="form.draw_type"
                      row
                      class="mt-n1"
                      :error-messages="formerror.draw_type"
                    >
                      <label class="mr-5">Draw type:</label>
                      <v-radio label="Straight" value="straight"></v-radio>
                      <v-radio label="Rambol" value="3d_rambol"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <v-text-field
                      dense
                      class="regular-field"
                      v-model="form.comlength"
                      label="Max input"
                      :error-messages="formerror.comlength"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="12">
                    <v-checkbox
                      dense
                      class="regular-field"
                      v-model="form.isDistributed"
                      label="Is default distributed?"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" lg="12">
                    <v-radio-group
                      dense
                      v-model="form.isrambolitos"
                      row
                      class="mt-n1"
                      :error-messages="formerror.isrambolitos"
                    >
                      <label class="mr-5">Rambol factor :</label>
                      <v-radio label="Straight" :value="1"></v-radio>
                      <v-radio label="Distributed" :value="0"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <v-text-field
                      dense
                      class="regular-field"
                      v-model="form.rambol_fraction"
                      label="Rambol fraction"
                      :error-messages="formerror.rambol_fraction"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <v-text-field
                      dense
                      class="regular-field"
                      v-model="form.rambol_min_bet"
                      label="Rambol min. bet (Repetition only)"
                      :error-messages="formerror.rambol_min_bet"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-textarea
                      dense
                      row
                      class="regular-field"
                      v-model="form.mechanics"
                      label="Mechanics"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </div>
              <div id="maxbet" class="container tab-pane fade table-responsive">
                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      dense
                      row
                      class="regular-field"
                      v-model="form.max_bet"
                      label="Max bet"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions class="actionButtons">
            <v-row no-gutters>
              <v-col cols="12">
                <v-btn color="red_button" @click="dialogForm = false"
                  >Back</v-btn
                >
                <span v-if="$role.restricAccess($route.name, 'edit')"
                  ><v-btn
                    color="green_button"
                    class="float-right"
                    @click="confirmPopup"
                    v-if="modalUpdate"
                    :loading="isLoadingBtn"
                    >Update</v-btn
                  ></span
                >
                <v-btn
                  color="green_button"
                  class="float-right"
                  @click="newData"
                  v-if="!modalUpdate"
                  :loading="isLoadingBtn"
                  >Save</v-btn
                >

                <span v-if="$role.restricAccess($route.name, 'edit')">
                  <v-btn color="info" class="float-right mr-3" dark :loading="isLoadingBtn" @click="updateData(true)" v-if="modalUpdate">Update (Bypass overide code)</v-btn>
                </span>

                <span v-if="$role.restricAccess($route.name, 'delete')"
                  ><v-btn
                    color="red_button"
                    class="float-right mr-3"
                    dark
                    :loading="isLoadingBtnDelete"
                    @click="deleteData(form.id)"
                    v-if="modalUpdate"
                    >Delete</v-btn
                  ></span
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </section>
    <section>
      <v-dialog
        v-model="dialogConfirm"
        max-width="450"
        :style="{ zIndex: 200 }"
        @keydown.esc="cancel"
        persistent
      >
        <v-card>
          <v-toolbar dark color="info" dense flat>
            <v-toolbar-title class="text-body-2 font-weight-bold text-white">
              Please confirm
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4">
            <v-row>
              <v-col cols="12 text-center" lg="12">
                <h2>Override code</h2>
                <h5>Please contact tech admin for override code</h5>
                <v-text-field
                  single-line
                  solo
                  v-model="form.verificationcode"
                  placeholder="Override code"
                  :append-icon="
                    value ? 'mdi-eye-off-outline' : 'mdi-eye-outline'
                  "
                  @click:append="() => (value = !value)"
                  :type="value ? 'password' : 'text'"
                  style="font-size:15px"
                  autofocus
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              text
              class="body-2 font-weight-bold"
              @click="dialogConfirm = false"
              >Back</v-btn
            >
            <v-btn
              color="info"
              class="body-2 font-weight-bold"
              @click="updateData(false)"
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </section>
    <confirm-dialog
      ref="confirm"
      class="custom-confirm-dialog"
    ></confirm-dialog>
  </section>
</template>

<script>
import VueUploadMultipleImage from 'vue-upload-multiple-image';
export default {
  components: { VueUploadMultipleImage },
  data() {
    return {
      value: String,
      schedules: [
        { name: "Sunday" },
        { name: "Monday" },
        { name: "Tuesday" },
        { name: "Wednesday" },
        { name: "Thursday" },
        { name: "Friday" },
        { name: "Saturday" },
      ],
      dialogForm: false,
      dialogConfirm: false,
      isLoadingBtn: false,
      isLoadingBtnDelete: false,
      formerror: {},
      modalUpdate: false,
      dt_headers: [
        {
          text: "ID",
          value: "id",
          name: "id",
          align: " d-none",
        },
        // {
        //   text: "Region",
        //   value: "region_name",
        //   name: "region_name",
        // },
        // {
        //   text: "Area",
        //   value: "area_name",
        //   name: "area_name",
        // },
        {
          text: "Draw",
          value: "name",
          name: "name",
        },
        {
          text: "Code name",
          value: "codename",
          name: "codename",
        },
        {
          text: "Schedule",
          value: "timeschedule",
          name: "timeschedule",
        },
        {
          text: "Opening time",
          value: "timetoopen",
          name: "timetoopen",
        },
        {
          text: "Cut-off time",
          value: "timetoclose",
          name: "timetoclose",
        },
        // { text: 'Estimated pot prize', value: 'potprize', name: 'potprize', sortable: false, searchable: false},
        {
          text: "Draw day",
          value: "schedule_draw",
          name: "schedule_draw",
        },

        // {
        //   text: "Status",
        //   value: "status",
        //   name: "status",
        // },
        // {
        //   text: "Actions",
        //   value: "actions",

        //   width: "10%",
        // },
      ],
      dt_options: {},
      dt_columns: {},
      dt_totalResult: 0,
      dt_searchInput: "",
      dt_searchQuery: "",
      dt_resultlist: [],
      dt_loading: true,
      dt_itemsPerPage: 50,
      dt_reload: "",
      dt_total_winnerprize: "",
       picture:[],
      form: new this.$Form({
        id: null,
        amount_increment: null,
        codename: null,
        draw_type: "straight",
        incremental_blocklevel: null,
        isrambolitos: 1,
        max_accumulated: null,
        max_combination: null,
        maxbet: null,
        maxinput: null,
        min_combination: null,
        minimumbet: null,
        name: null,
        numberformat: null,
        sales_per_blocklevel: null,
        salestreshold: null,
        schedule_draw: null,
        timeschedule: null,
        timetoclose: null,
        timetoopen: null,
        winning_share: null,
        zone_id: null,
        status: 1,
        max_bet: "",
        mechanics: null,
        comlength: null,
        verificationcode: null,
        rambol_fraction: null,
        isDistributed: 0,
        rambol_min_bet: null,
        gallery: [],
        iconimage: [],
        isbypass: false,
      }),
      region_list: [],
      arealist: [],
      agent_id: null,
      zone_list: null,
      filter: {
        region_id: null,
        zone_id: null,
        status: null,
      },
    };
  },
  methods: {
    abri(val){
      let schedules = val.split(', ');
      let arr = [
          { "Sunday": 'Sun' },
          { "Monday": 'Mon' },
          { "Tuesday": 'Tue' },
          { "Wednesday": 'Wed' },
          { "Thursday": 'Th' },
          { "Friday": 'Fri' },
          { "Saturday": 'Sat' },
      ];
      let scheds = [];

      schedules.forEach((element, index) => {
        // scheds.push(arr[index]);
      console.log(element);
      });
      // console.log(scheds);
    },
    isEditButtonDisabled(data) {
      if (this.$store.state.currentUser.agent_data.id == data.agent_id) {
        return false;
      }
      return true;
    },
    schedule_draw_format(val) {
      let data = [];
      val = JSON.parse(val);
      val.forEach(element => {
          data.push(element.name);
      });
      return data.join(', ');
    },
    modalForm() {
      this.modalUpdate = false;
      this.form.reset();
      this.dialogForm = true;
    },
    copyClipboard(data) {
      data = data.split(" / ");
    },
    async newData() {
      if (this.form.schedule_draw) {
        if (this.form.schedule_draw.length) {
          let schedule_draw = [];
          this.form.schedule_draw.forEach((element) => {
            schedule_draw.push({ name: element });
          });
          this.form.schedule_draw = schedule_draw;
        }
      }
      this.isLoadingBtn = true;
      this.form
        .post(this.$_CONFIG.api("API_DRAWS"))
        .then(({ data }) => {
          this.isLoadingBtn = false;
          this.getDataFromApi();
          this.dialogForm = false;
          // this.$Swal.fire(
          //   "Success!",
          //   "Record has been successfully added.",
          //   "success"
          // );
          this.$toast.fire({
            icon: "success",
            title: "Record has been successfully added.",
          });
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data.errors;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    async findData(data) {
      if(this.form.gallery != undefined){
          this.form.gallery.splice(0, 1);
      }
    
      this.form.gallery = [];
      console.log(data.icon);
      this.form.reset();
      this.formerror = {};
      this.form.reset();


      
     if(data.icon != null){
  
          this.picture.push({
          'path': this.$urladmin+'/public/img/drawicons/'+data['icon'],
          'default': 1,
          'highlight': 1,
          'name': data['icon'],
          'caption': 'caption to display. receive'
        })
        console.log('push');
      
    
     }
      this.form.fill(data);
       if(data.icon != null){
       
          this.form.gallery = this.picture;
       }
    
      this.form.schedule_draw = JSON.parse(data.schedule_draw);
      this.modalUpdate = true;
      this.dialogForm = true;
    },
    async confirmPopup() {
      this.dialogConfirm = true;
    },
    async deleteData(id) {
      this.isLoadingBtnDelete = true;
      if(
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to delete this record?"
        )
      ){
        this.form
          .delete(this.$_CONFIG.api("API_DRAWS") + "/" + this.form.id)
          .then(() => {
            this.isLoadingBtnDelete = false;
            this.dialogForm = false;
            this.getDataFromApi();
            this.$toast.fire({
              icon: "success",
              title: "Record has been successfully deleted.",
            });
          })
          .catch(() => {
            this.isLoadingBtnDelete = false;
            this.$toast.fire({ icon: "error", title: "Something went wrong!" });
          });
      } else {
        this.isLoadingBtnDelete = false;
      }
    },
    async updateData(isBypass = false) {
      const isAlreadyFormatted = this.$_.hasIn(
        this.form.schedule_draw,
        "0.name"
      );
      if (!isAlreadyFormatted) {
        if (this.form.schedule_draw.length) {
          let schedule_draw = [];
          this.form.schedule_draw.forEach((element) => {
            schedule_draw.push({ name: element });
          });
          this.form.schedule_draw = schedule_draw;
        }
      }

      if(isBypass){
        this.form.isbypass = true;
      }else{
        this.form.isbypass = false;
      }

      this.isLoadingBtn = true;
      this.form
        .put(this.$_CONFIG.api("API_DRAWS") + "/" + this.form.id)
        .then((data) => {
          if (data.data == "error") {
            this.isLoadingBtn = false;
            this.$toast.fire({ icon: "error", title: "Override code error" });
          } else {
            this.isLoadingBtn = false;
            this.dialogConfirm = false;
            this.dialogForm = false;
            this.getDataFromApi();
            this.$toast.fire({
              icon: "success",
              title: "Record has been successfully updated.",
            });
          }
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data.errors;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    paramsfilter() {
        let subagent =
        this.$store.state.currentUser.agent_data.level != 0
          ? this.$store.state.currentUser.agent_data.id
          : null;
      try {
        if (this.$refs.agent_autocomplete.autocomplete_model.id) {
          subagent = this.$refs.agent_autocomplete.autocomplete_model.id;
        }
      } catch (error) {
        subagent =
          this.$store.state.currentUser.agent_data.level != 0
            ? this.$store.state.currentUser.agent_data.id
            : null;
      }
      return {
        ...this.dt_options,
        searchdata: this.dt_searchQuery,
        region_id: this.filter.region_id,
        zone_id: this.filter.zone_id,
        status: this.filter.status,
        agent_id: subagent,
      };
    },
    async getDataFromApi() {
      this.dt_loading = true;
      var paramsfilter = await this.paramsfilter();
      this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
      let params = await this.$YajraDT.params(
        paramsfilter,
        this.dt_options,
        this.dt_itemsPerPage,
        this.dt_columns
      );
      let apiPath = await this.$_CONFIG.api("API_DRAWS");

      await this.$axios
        .get(apiPath + "?" + this.$.param(params))
        .then((res) => {
          if (this.dt_totalResult != res.data.recordsFiltered) {
            this.dt_options.page = 1;
          }

          // const obj = JSON.parse(res.data.data.schedule_draw);
          // console.log(res.data.data.schedule_draw);

          this.dt_resultlist = res.data.data;
          this.dt_totalResult = res.data.recordsFiltered;
          this.dt_loading = false;
        })
        .catch((err) => {
          this.dt_loading = false;
          console.log(err);
        });

      var unwatch = this.$watch(
        "dt_options.page",
        function(newValue, oldValue) {
          this.getDataFromApi();
          unwatch();
        },
        { deep: true }
      );
    },
    async zonelist() {
      let response = await this.$axios.get(
        this.$_CONFIG.api() + "/allzonelist"
      );
      this.zone_list = response.data;
    },
    async regionlist() {
      let response = await this.$axios.get(
        this.$_CONFIG.api() + "/allregionlist"
      );
      this.region_list = response.data;
    },
    getarealist() {
      this.$axios
        .get(this.$_CONFIG.api() + "/allzonelist")
        .then((res) => {
          this.arealist = res.data;
          // console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async beforeRemove (index, done, fileList) {
                  // // var r = confirm("remove image")
                  // // if (r == true) {
                  //     Swal.fire({
                  //         title: 'Are you sure?',
                  //         text: "You won't be able to revert this!",
                  //         type: 'warning',
                  //         showCancelButton: true,
                  //         confirmButtonColor: '#3085d6',
                  //         cancelButtonColor: '#d33',
                  //         confirmButtonText: 'Yes, delete it!'
                  //         }).then((result) => {
                  //         if (result.value) {
                  //             done();
                  //         }
                  //     });
                  // // }else{
                  // // }

                   if(
                  await this.$refs.confirm.open(
                    "Confirm",
                    "Are you sure you want to remove this icon?"
                  )
                ){
                  done();
                }
              },
          editImage (formData, index, fileList) {
             this.form.iconimage = fileList;
          },
          uploadImageSuccess(formData, index, fileList) {
                this.form.gallery = fileList;
                this.form.iconimage = fileList;
            },
  },
  created() {
    this.zonelist();
    this.getDataFromApi();
    this.regionlist();
    this.getarealist();
  },
  mounted() {},
};
</script>
<style scoped></style>